function init(appID = '') {
  window.FB.init({
    appId: appID,
    version: 'v22.0',
  })
}

/**
 *
 * @returns {Promise<fb.AuthResponse>}
 */
function login() {
  return new Promise((resolve, reject) => {
    window.FB.login(
      res => {
        // handle the response
        if (res.status === 'connected') {
          resolve(res.authResponse)
          return
        }
        reject(new Error(JSON.stringify(res)))
      },
      { scope: 'email' }
    )
  })
}

/**
 *
 * @param {string} locale
 * @returns {Promise<{id: string,
 *  name?: string,
 *  email?: string,
 *  birthday?: string,
 *  gender?: string,
 * }>}
 */
function getProfile(locale = 'en-us') {
  return new Promise((resolve, reject) => {
    window.FB.api('/me', { locale, fields: ['id', 'name', 'email', 'birthday', 'gender'] }, res => {
      if (res.error) {
        reject(res.error)
        return
      }
      resolve(res)
    })
  })
}

export const FacebookDialogLogin = {
  init,
  login,
  getProfile,
}
